import {FunctionalComponent, h} from "preact";
import {makePollAnswerMsg} from "./InputUIService";
import {useState} from "preact/hooks";
import {IcoCheckboxButt} from "../components/icons";

export const MultiCheckbox: FunctionalComponent<{
    question: any; answerCallback: (answerRawObj: any) => void;
}> = ({question, answerCallback}) => {

    /* we create an array of booleans to represent the checked state of the various answers */
    const [answersCheckedState, setAnswersCheckedState] = useState(question.answers.map(() => false));
    const [selectedGroupID, setSelectedGroupID] = useState<number>(-1);

    function castAnswer(): void {
        const selectedAnswersTxtA = [];
        const selectedAnswersChoiceIdA = [];

        for (let i = 0; i < answersCheckedState.length; i++) {
            if (answersCheckedState[i]) {
                selectedAnswersTxtA.push(question.answers[i].txt_ext ? question.answers[i].txt_ext : question.answers[i].txt);
                selectedAnswersChoiceIdA.push(question.answers[i].choice_id);
            }
        }

        const pollAnswerMsg = makePollAnswerMsg({
            txt: selectedAnswersTxtA.join(', '),
            ansID: selectedAnswersChoiceIdA
        }, question);

        answerCallback(pollAnswerMsg);
    }

    function toggleAnswerSelection(answerID: number, groupID: number): void {
        const answerCheckedState: boolean = answersCheckedState[answerID];

        if (!answerCheckedState) {
            if (selectedGroupID !== groupID) {
                for (let i = 0; i < answersCheckedState.length; i++) {
                    answersCheckedState[i] = false;
                }
                setSelectedGroupID(groupID);
            }
        }
        answersCheckedState[answerID] = !answersCheckedState[answerID];
        /** for functional components, render is not triggered if new state is equal to its previous value,
         * so we must send a new copy of the array */
        setAnswersCheckedState([...answersCheckedState]);
    }
  
    return <form name="inputForm"
                 role="form"
                 className="{invalidSubmitted: showErr()}">

        <fieldset>
            <legend>Answers</legend>
            <div id="multiCheckbox">
                {question.groups.map((rawGroup: any, groupIdx: number) => {
                  return (<ul> {
                      rawGroup.map(
                        (ansID: number) => (
                          <li key={ansID}>
                            <a onClick={(e) => {
                              e.preventDefault();
                              toggleAnswerSelection(ansID, groupIdx);
                            }}
                               className={answersCheckedState[ansID] ? 'butt sel' : 'butt'}>
                              <i className="check">✔</i>
                              <i className="uncheck" />
                              <span>{question.answers[ansID].txt}</span>
                            </a>
                          </li>
                        )
                      )}</ul>);
                })
                }
                <button tabIndex={12} className="send" onClick={(e) => {
                    e.preventDefault();
                    castAnswer();
                }}>
                    <IcoCheckboxButt />
                    <span>send</span>
                </button>
            </div>
        </fieldset>
    </form>;
}
